// Default options for the plugin.
import videojs from 'video.js';

import OverlayBackButton from './OverlayBackButton';
import OverlayForwardButton from './OverlayForwardButton';
import OverlayButton from './OverlayButton';
import Overlay from './Overlay';

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
const onPlayerReady = (player, options) => {
  player.addClass('vjs-core-playlist-overlay');

  // adding AT the play button index because this will actually bump it forward.
  player.getChild('controlBar').addChild('PlaylistOverlayButton', options);

  player.addChild('PlaylistOverlay', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function share
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
function playlistOverlay(options) {
  onPlayerReady(this, options);
}

// Registers the necessary components and the plugin
videojs.registerComponent('PlaylistOverlayBackButton', OverlayBackButton);
videojs.registerComponent('PlaylistOverlayForwardButton', OverlayForwardButton);
videojs.registerComponent('PlaylistOverlayButton', OverlayButton);
videojs.registerComponent('PlaylistOverlay', Overlay);

videojs.registerPlugin('playlistOverlay', playlistOverlay);

export default playlistOverlay;
